<template>
<!-- 路由出口 -->
  <router-view></router-view>
</template>

<script>
export default {

}
</script>

<style>

</style>